import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-compass-3-line text-sm"></i>
            内容导航
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            吃瓜导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            按主题分类浏览内容，快速找到你最关心的八卦话题
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.slice(0, 4).map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl p-5 border border-background-200 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-md group"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 flex-shrink-0">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-foreground-950 text-sm font-bold whitespace-nowrap">{item.title}</h3>
                    <span className="text-primary-500 text-xs font-medium bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">{item.count}</span>
                  </div>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indexItems.slice(4).map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl p-5 border border-background-200 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-md group"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-all duration-300 flex-shrink-0">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-foreground-950 text-sm font-bold whitespace-nowrap">{item.title}</h3>
                    <span className="text-accent-600 text-xs font-medium bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">{item.count}</span>
                  </div>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}